interface AnalyticsEvent {
  name: string;
  properties?: Record<string, unknown>;
}

export function useAnalytics() {
  const trackEvent = async (event: AnalyticsEvent) => {
    try {
      // Replace this with your actual analytics implementation
      await fetch('/api/analytics/events', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(event),
      });
    } catch (error) {
      console.error('Failed to track analytics event:', error);
    }
  };

  return { trackEvent };
} 